import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { MailingId } from '../../types/mailing-interface'

export const useUserData = ({
  mailingId,
  isFetchAllowed,
}: {
  mailingId: MailingId
  isFetchAllowed?: boolean
}) => {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, { id: number; email: string }>({
    method: RequestMethodsEnum.get,
  })

  const { data } = useControlledSwr(
    () => user && `/api/dashboard/manager/mailing/${mailingId}/user`,
    fetcher,
    undefined,
    isFetchAllowed,
  )

  return {
    userData: data,
  }
}
